import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { useTimer } from '../hooks';
import media from '../style/media';
import { useMediaPredicate } from 'react-media-hook';
import { useTheme } from 'styled-components';
import { fontWeight, spacing } from '../style/tokens';

// Softer cream than pure white for the timer readout
const TIMER_TEXT_COLOR = '#F5EFE0';

const TimerWrapper = styled.div<{ bg: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing.sm} ${spacing.lg};
  border-radius: 18px;
  background: ${({ bg }) => bg};
`;

const Value = styled.div<{ color: string }>`
  font-size: 24px;
  font-weight: ${fontWeight.normal};
  font-family: inherit;
  color: ${({ color }) => color};
  font-variant-numeric: tabular-nums;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
`;

interface TimerProps {
  started: boolean;
  durationSeconds: number;
}

const Timer = ({ started, durationSeconds }: TimerProps) => {
  const isMediaTablet = useMediaPredicate('(min-width: 1000px)');
  const elapsedSeconds = useTimer(started, durationSeconds);
  const intl = useIntl();
  const { gradient1 } = useTheme();

  const remainingSeconds = Math.max(0, durationSeconds - elapsedSeconds);

  const formatSeconds = useCallback(
    (seconds) => String(seconds),
    [],
  );

  return (
    <TimerWrapper bg={`${gradient1}33`}>
      <Value color={TIMER_TEXT_COLOR}>
        {formatSeconds(remainingSeconds)}s
      </Value>
    </TimerWrapper>
  );
};

export default Timer;
